<template>
  <div class="navbar-brand">
    <a class="navbar-item" href="/">
      <span class="icon-text">
        <span class="icon">
          <i class="fa fa-shield-alt"></i>
        </span>
          <b>{{title}}</b>
      </span>
    </a>
  </div>
</template>
<script>
import { TITLE } from 'common/const.js'
export default {
  name: 'Brand',
  data () {
    return {
      title: TITLE
    }
  }
}
</script>
